import React, { useState, useEffect } from "react";
import { clearCacheUrl } from "../../shared/config";

function WithClearCache(wrappedComponent) {
    function ClearCacheComponent() {
        const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

        useEffect(() => {
            let isMounted = true; // Track whether the component is mounted

            const refreshCacheAndReload = async () => {
                if (caches) {
                    try {
                        const cacheNames = await caches.keys();
                        await Promise.all(cacheNames.map(name => caches.delete(name)));
                        await unregisterServiceWorkers(); // Unregister service workers if necessary
                    } catch (error) {
                        console.error("Error clearing cache:", error);
                    }
                }
                window.location.reload();
            };

            const unregisterServiceWorkers = async () => {
                const registrations = await navigator.serviceWorker.getRegistrations();
                registrations.forEach((registration) => {
                    registration.unregister();
                });
            };

            const fetchMetaData = async () => {
                try {
                    // Fetch latest build data from meta.json on the server
                    const response = await fetch(clearCacheUrl);
                    const meta = await response.json();
                    const latestVersionDate = Number(meta.buildDate); // Assuming buildDate is a timestamp

                    // Retrieve the current build date from local storage
                    const currentVersionDate = Number(localStorage.getItem('buildDate'));
                    console.log("Current Build Version:", currentVersionDate);

                    // Check if we need to refresh
                    const shouldForceRefresh = !currentVersionDate || latestVersionDate > currentVersionDate;

                    if (isMounted) {
                        if (shouldForceRefresh) {
                            console.log("hello"); // Should print "hello" if a refresh is needed
                            // Update local storage with the latest build date
                            localStorage.setItem('buildDate', latestVersionDate);
                            console.log('Build Version changed to:', latestVersionDate);
                            setIsLatestBuildDate(false);
                            await refreshCacheAndReload();
                        } else {
                            setIsLatestBuildDate(true);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching meta data:", error);
                    // Handle fetch error as needed
                }
            };

            fetchMetaData();

            return () => {
                isMounted = false; // Cleanup function to set the flag to false
            };
        }, []);

        return (
            <React.Fragment>
                {isLatestBuildDate ? wrappedComponent : null}
            </React.Fragment>
        );
    }

    return ClearCacheComponent;
}

export default WithClearCache;
